import { Empty, Spin, Typography } from 'antd';
import type { NewInZoomlogiProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';
import { ChevronRightIcon } from '@/assets/icons/icons';

const NewInZoomlogi = ({
  whatsNew,
  loading,
  onSelect,
  onViewAll,
}: NewInZoomlogiProps) => {
  return (
    <section className={styles.newInZoomlogi}>
      <h2 className={styles.newInZoomlogiTitle}>New in Zoomlogi</h2>

      {loading ? (
        <div className={styles.helpSectionLoading}>
          <Spin />
        </div>
      ) : (
        !whatsNew?.items?.length && (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )
      )}

      <div className={styles.newInZoomlogiList}>
        {whatsNew?.items?.slice(0, 3)?.map((item) => (
          <button
            key={item?.id}
            type='button'
            className={styles.newInZoomlogiRow}
            onClick={() => onSelect(item)}
          >
            <Typography.Text
              className={styles.newInZoomlogiRowTitle}
              ellipsis={{ tooltip: item?.title }}
            >
              {item?.title}
            </Typography.Text>
            <span className={styles.newInZoomlogiRowIcon}>
              <ChevronRightIcon width={16} height={16} fill='currentColor' />
            </span>
          </button>
        ))}
      </div>
      {(whatsNew?.total ?? 0) > 3 && (
        <button
          type='button'
          className={styles.newInZoomlogiViewAll}
          onClick={onViewAll}
        >
          All {whatsNew?.total} new features
        </button>
      )}
    </section>
  );
};

export default NewInZoomlogi;
